import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Box } from 'grommet';
import { FormNext } from 'grommet-icons';
import NoAuthLayout, {
  StyledSubmissionInput, StyledSubmissionField, StyledSubmissionAnchor,
} from '@Components/Layout/NoAuth';
import { useAppTheme } from '@Components/Context';
import { AppButton } from '@Components/Control';
import { authLogInRequest } from '@Actions';
import { paths } from '@Components/configs';

const LoginPage = ({ small, logIn }) => {
  // Prefill email from localStorage if available
  const [emailValue, setEmailValue] = React.useState('');
  const [hasPrefill, setHasPrefill] = React.useState(false);

  const { theme } = useAppTheme();

  React.useEffect(() => {
    const stored = window.localStorage.getItem('prefillLoginEmail');
    if (stored) {
      setEmailValue(stored);
      setHasPrefill(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { email, password } = e.value;
    logIn(email, password);
    // Clear prefill after login
    window.localStorage.removeItem('prefillLoginEmail');
  };

  const pageTitle = hasPrefill ? 'Welcome to Redflag' : 'Welcome back';

  return (
    <NoAuthLayout
      seoConfig={null}
      title={pageTitle}
      small={small}
    >
      <Form onSubmit={(e) => handleSubmit(e)}>
        <StyledSubmissionField required name="email" htmlFor="email" type="email">
          <StyledSubmissionInput
            plain
            name="email"
            type="email"
            placeholder="Email"
            value={emailValue}
            onChange={(e) => setEmailValue(e.target.value)}
          />
        </StyledSubmissionField>
        <StyledSubmissionField required name="password" htmlFor="password" type="password">
          <StyledSubmissionInput
            plain
            name="password"
            type="password"
            placeholder="Password"
          />
        </StyledSubmissionField>
        <AppButton
          overrideHover
          type="submit"
          level="authSubmit"
          bgColor={theme.button.primaryBg}
          color={theme.button.primaryText}
          label="Sign In"
          alignSelf="center"
        />
        <Box pad={{ top: '1.5rem' }} width="100%" align="center">
          <Box gap="0.5rem">
            <Box direction="row" gap="0.25rem" align="center" justify="start">
              <FormNext size="0.75rem" color={theme.page.altHighlight} style={{ paddingTop: '1px' }} />
              <StyledSubmissionAnchor
                label="Forgot your password?"
                path={paths.forgotPassword}
                color={theme.page.primaryText}
                hoverColor={theme.page.altHighlight}
              />
            </Box>
            <Box direction="row" gap="0.25rem" align="center" justify="start">
              <FormNext size="0.75rem" color={theme.page.altHighlight} style={{ paddingTop: '1px' }} />
              <StyledSubmissionAnchor
                label="Don't have an account? Sign up"
                path={paths.customerOnboarding}
                color={theme.page.primaryText}
                hoverColor={theme.page.altHighlight}
              />
            </Box>
          </Box>
        </Box>
      </Form>
    </NoAuthLayout>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ logIn: authLogInRequest }, dispatch);
}

LoginPage.propTypes = {
  small: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(LoginPage);
